import React from 'react';

interface VideoResultProps {
  generatedVideo: {
    url: string;
    duration: number;
    seed: number;
    prompt: string;
  };
  onGenerateNew: () => void;
  onUseVideo: (videoUrl: string, prompt: string, duration: number) => void;
  onClose: () => void;
}

const VideoResult: React.FC<VideoResultProps> = ({
  generatedVideo,
  onGenerateNew,
  onUseVideo,
  onClose
}) => {
  const handleUseVideo = () => {
    onUseVideo(generatedVideo.url, generatedVideo.prompt, generatedVideo.duration);
    onClose();
  };

  return (
    <>
      {/* Generated Video Display */}
      <div style={{ marginBottom: '20px' }}>
        <h3 style={{ margin: '0 0 15px 0', color: '#8b5cf6', fontSize: '18px' }}>
          🎬 Your Generated Video
        </h3>
        
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <video
            src={generatedVideo.url}
            controls
            autoPlay
            muted
            loop
            style={{
              width: '100%',
              maxWidth: '600px',
              borderRadius: '8px',
              border: '2px solid #8b5cf6'
            }}
          />
        </div>

        {/* Video Details */}
        <div style={{ backgroundColor: '#1a1a1a', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
          <h4 style={{ margin: '0 0 10px 0', color: '#8b5cf6', fontSize: '16px' }}>
            Video Details
          </h4>
          <p style={{ margin: '5px 0', fontSize: '14px', color: '#ccc' }}>
            <strong>Duration:</strong> {generatedVideo.duration} seconds
          </p>
          <p style={{ margin: '5px 0', fontSize: '14px', color: '#ccc' }}>
            <strong>Prompt:</strong> {generatedVideo.prompt}
          </p>
          <p style={{ margin: '5px 0', fontSize: '14px', color: '#ccc' }}>
            <strong>Seed:</strong> {generatedVideo.seed}
          </p>
        </div>
      </div>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
        <button
          onClick={onGenerateNew}
          style={{
            padding: '12px 24px',
            border: '1px solid rgba(255,255,255,0.2)',
            backgroundColor: 'transparent',
            color: 'white',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          🔄 Generate a New One
        </button>
        <button
          onClick={handleUseVideo}
          style={{
            padding: '12px 24px',
            background: 'linear-gradient(135deg, #10b981, #059669)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          ✅ Use This Video
        </button>
      </div>
    </>
  );
};

export default VideoResult;